import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
const store = createStore({
  plugins: [createPersistedState()],
  state: {
    EmailID: "",
  },

  getters: {
    get_user_email_id: (state) => state.EmailID,
  },
  mutations: {
    SET_USER_EMAIL_ID(state, username) {
      state.EmailID = username;
    },
  },
  actions: {},
  modules: {},
});

export default store;
